<template>
        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" :static="true" :title="Core.Definition.getDefinition('Connexion')" v-model="dataShow"  :hide-footer="true">
            <Request
                    ref="requestSession"
                    :onRequestSuccess="onRequestSessionSuccess"
                    :onRequestError="onRequestSessionError"
                    root="/session">
                <slot slot="body">
                    <b-form>
                        <p class="text-muted">
                            {{Core.Definition.getDefinition('Connectez-vous à votre compte')}}</p>
                        <b-input-group class="mb-3">
                            <b-input-group-prepend>
                                <b-input-group-text><i class="fa fa-user"></i>
                                </b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input v-model="dataUser" type="text" class="form-control"
                                          :placeholder="Core.Definition.getDefinition('Utilisateur')"
                                          autocomplete="username email"/>
                        </b-input-group>
                        <b-input-group>
                            <b-input-group-prepend>
                                <b-input-group-text><i class="fa fa-lock"></i>
                                </b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input type="password" v-model="dataPassword" class="form-control"
                                          :placeholder="Core.Definition.getDefinition('Mot de passe')"
                                          autocomplete="current-password"/>
                        </b-input-group>
                        <div class="text-right">
                            <b-button @click="onPasswordRecoveryClick" variant="link" class="px-0 mb-2">
                                {{Core.Definition.getDefinition('Mot de passe oublié?')}}
                            </b-button>
                        </div>
                    </b-form>
                </slot>
            </Request>
            <hr/>
            <div class="text-right">
                <b-button-group>
                    <b-button :disabled="dataProcessing" @click="open=false" class="btn btn-light">{{Core.Definition.getDefinition('Fermer')}}</b-button>
                    <b-button :disabled="dataProcessing" @click="onCreateAccountClick" class="btn btn-light">{{Core.Definition.getDefinition('Créer un compte')}}</b-button>
                    <b-button :disabled="dataProcessing" @click="login" variant="primary" class="btn">{{Core.Definition.getDefinition('Connexion')}}</b-button>
                </b-button-group>
            </div>
        </b-modal>
</template>

<script>
    import Request from '../components/Request'
    import Alert from '../components/Alert'
    import CryptoJS from 'crypto-js'
    export default {
        name: 'ModalLogin',
        components: {
            Request,
            Alert
        },
        props: {},
        watch: {},
        mounted() {
        },
        data: () => {
            return {
                Core: window.Core,
                dataShow: false,
                dataUser: '',
                dataPassword: '',
                dataProcessing: false
            }
        },
        computed: {
            open: {
                set(val) {
                    this.dataShow = val
                },
                get() {
                    return this.dataShow
                }
            }
        },
        methods: {
            login(e) {
                this.dataProcessing = true
                e.preventDefault()
                let password = CryptoJS.MD5(this.dataPassword).toString()
                this.$refs.requestSession.clearArgs()
                this.$refs.requestSession.addArg('user', this.dataUser)
                this.$refs.requestSession.addArg('password', password)
                this.$refs.requestSession.addArg('login', '1')
                this.$refs.requestSession.request()
            },
            onRequestSessionSuccess(data) {
                if (data.alert !== undefined) {
                } else {
                    this.$emit('onLoginSuccess')
                }

                if (this.$refs.requestSession!==undefined&&this.$refs.requestSession.$parent!==undefined) {
                    this.$refs.requestSession.$parent.$parent.$parent.$parent.$parent.$children[0].$refs.sidebarNav.resetNav()
                }

                this.dataProcessing = false
            },
            onRequestSessionError() {
                this.dataProcessing = false
            },
            onPasswordRecoveryClick() {
                this.open = false
                this.$emit('onPasswordRecoveryClick')
            },
            onCreateAccountClick() {
                this.open = false
                this.$emit('onCreateAccountClick')
            }
        }
    }
</script>